export default __webpack_public_path__ + "static/media/menu_4.faa46b55.png";